import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import './Navigation.css'

const Navigation = () => {
    return (
        <Navbar collapseOnSelect expand="lg" className="text-white py-4" variant="dark">
            <Container className='fs-5'>
                <Navbar.Brand as={Link} to="/home" >Zahid Hasan</Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link as={Link} to="/projects" className="nav-item" >My Projects</Nav.Link>
                        <Nav.Link as={HashLink} to="/home#about" className="nav-item">About</Nav.Link>
                        <Nav.Link as={Link} to="/blogs" className="nav-item">Blogs</Nav.Link>
                        <Nav.Link href="https://drive.google.com/file/d/1ESKmQ5wd6UToAMui43yKEqsjDn6penkx/view?usp=sharing" target="_blank" className="nav-item">Resume</Nav.Link>
                        <Nav.Link as={HashLink} to="/home#contact" className="nav-item">Contact</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Navigation;